import { Routes, RouterModule } from "@angular/router";
import { imvoCreateUserComponent } from "./+imvo/create-user/create-user.component";
import { KmsjCreateUserComponent } from "./+kmsj/create-user/create-user.component";
import { CreateUserComponent } from './+sunrise/create-user/create-user.component';

import { UserComponent } from './+user/user.component';
import { nudbCreateUserComponent } from "./+smat-nudb/create-user/create-user.component";
import { nasaCreateUserComponent } from "./+smat-nasa/create-user/create-user.component";

export const routes:Routes = [
  {
    path: 'login-otp',
    loadChildren: './+login-otp/login-otp.module#LoginOtpModule'
  },
  {
    path: 'login',
    loadChildren: './+login/login.module#LoginModule'
  },
  
  {
    path: 'forgot-password',
    loadChildren: './+forgot/forgot.module#ForgotModule'
  },
  {
    path: 'locked',
    loadChildren: './+locked/locked.module#LockedModule'
  },
  {
    path: 'reset-password',
    loadChildren: './+reset/reset.module#ResetModule'
  },
  {
    path: 'sunrise/create-user',  // Web Form - Create User
    component: CreateUserComponent,
    data: {
      pageTitle: 'Create User'
    }
  },
  {
    path: 'auth/imvo/create-user',  // Web Form - Create User
    component: imvoCreateUserComponent,
    data: {
      pageTitle: 'Create User'
    }
  },
  {
    path: 'smat-nasa/create-user',  // Web Form - Create User
    component: nasaCreateUserComponent,
    data: {
      pageTitle: 'Register User'
    }
  },

  {
    path: 'smat-nudb/create-user',  // Web Form - Create User
    component: nudbCreateUserComponent,
    data: {
      pageTitle: 'Register User'
    }
  },
  {
    path: 'user-verify/:userId/:email',  // Web Form - Verfiy UserId and Email
    component: UserComponent,
    data: {
      pageTitle: 'User Verify'
    }
  },
  // {
  //   path: 'kmsj/create-user',  // Web Form - Create User
  //   component: KmsjCreateUserComponent,
  //   data: {
  //     pageTitle: 'Create User'
  //   }
  // },

  ];

export const routing = RouterModule.forChild(routes);
